import React from 'react';
import Svg, { Line } from 'react-native-svg';

export interface DashedDividerProps {
    color: string;
}

/**
 * Horizontal dashed divider drawn via react-native-svg — plain
 * `borderStyle: 'dashed'` doesn't render reliably on Android.
 */
export function DashedDivider({ color }: Readonly<DashedDividerProps>) {
    return (
        <Svg height={1} width="100%">
            <Line
                x1="0"
                y1="0.5"
                x2="100%"
                y2="0.5"
                stroke={color}
                strokeWidth={1}
                strokeDasharray="4,4"
            />
        </Svg>
    );
}

export default DashedDivider;
